export const qrCodeParamKey = 'qrCode';
